import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      name: '',
      description: '',
      img: '',
      tagline: '',
    },
  ],
  category: {
    name: '',
    description: '',
    img: '',
    tagline: '',
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/categories?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function categories(state = initialState, action) {
  switch (action.type) {
    case types.CATEGORIES_FETCH_SUCCESS:
      // console.log("CATEGORIES_FETCH_SUCCESS action.res:", action.res);
      return assign({}, state, action.res);
    case types.CATEGORIES_FETCH_ERROR:
    case types.CATEGORY_FETCH_ERROR:
    case types.CATEGORY_EDIT_ERROR:
    case types.CATEGORY_SET_ERROR:
    case types.CATEGORY_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.CATEGORY_FETCH_SUCCESS:
    case types.CATEGORY_EDIT_SUCCESS:
    case types.CATEGORY_SET_SUCCESS:
      return assign({}, state, {
        category: action.res,
      });
    case types.CATEGORY_DELETE_SUCCESS:
      return assign({}, state, {
        categoryDelete: action.res.ok,
      });
    case types.CATEGORIES_CLEAR_ERRORS:
    case types.CATEGORY_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default categories;



// WEBPACK FOOTER //
// ./src/reducers/categories.js